import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  SignUpCompanyData,
  SignUpInformationsData,
  SignUpState,
} from '../../components/sign-up/interfaces/sign-up-store.interface';
import countriesData from '../../../shared/data/temporary_country_list.json';

const initialState: SignUpState = {
  company: {
    country: countriesData[0].pays,
    vatNumber: '',
    siret: '',
    industryType: null,
    legalStatus: null,
    name: '',
    address1: '',
    address2: '',
    address3: '',
    city: '',
    postalCode: '',
    phoneNumber: '',
  },
  informations: {
    email: '',
    firstname: '',
    lastname: '',
    login: '',
  },
};

@Injectable({
  providedIn: 'root',
})
export class SignUpStoreService {
  private readonly stateSubject = new BehaviorSubject<SignUpState>(
    initialState,
  );

  public getState$(): Observable<SignUpState> {
    return this.stateSubject.asObservable();
  }

  public getSnapshot(): SignUpState {
    return this.stateSubject.value;
  }

  public getCompanySnapshot(): SignUpCompanyData {
    return this.getSnapshot().company;
  }

  public getInformationsSnapshot(): SignUpInformationsData {
    return this.getSnapshot().informations;
  }

  public setState(state: SignUpState): void {
    this.stateSubject.next(state);
  }

  public patchCompany(company: Partial<SignUpCompanyData>): void {
    const currentState = this.getSnapshot();

    this.stateSubject.next({
      ...currentState,
      company: {
        ...currentState.company,
        ...company,
      },
    });
  }

  public patchInformations(
    informations: Partial<SignUpInformationsData>,
  ): void {
    const currentState = this.getSnapshot();

    this.stateSubject.next({
      ...currentState,
      informations: {
        ...currentState.informations,
        ...informations,
      },
    });
  }

  public setCompany(company: SignUpCompanyData): void {
    const currentState = this.getSnapshot();

    this.stateSubject.next({
      ...currentState,
      company,
    });
  }

  public setInformations(informations: SignUpInformationsData): void {
    const currentState = this.getSnapshot();

    this.stateSubject.next({
      ...currentState,
      informations,
    });
  }

  public reset(): void {
    this.stateSubject.next(initialState);
  }

  public isInitialState(): boolean {
    const state = this.getSnapshot();

    return JSON.stringify(state) === JSON.stringify(initialState);
  }
}
